import apiService from '../apiService';
import { fetchAllPaginatedList } from '@/utils/paginatedFetch';

const CATEGORY_PAGE_SIZE = 100;

// ========== 商品 (Products) ==========
export const getProducts = async (params = {}) => {
    return apiService.GET('/api/admin/shop-products', params);
};

export default {
    getProducts
};

/**
 * 取得商品分類列表
 * @param {Object} params - 查詢參數
 * @param {number} params.page - 頁碼
 * @param {number} params.per_page - 每頁筆數
 * @returns {Promise} API 響應
 */
export const getShopCategories = async (params = {}) => {
    const url = '/api/admin/shop-categories';
    const safeParams = { ...params };
    if (Number(safeParams.per_page) > CATEGORY_PAGE_SIZE) {
        safeParams.per_page = CATEGORY_PAGE_SIZE;
    }
    return apiService.GET(url, safeParams);
};

/**
 * 取得全部商品分類（自動翻頁合併；每頁最多 100）
 * @param {Object} params - 額外篩選
 * @returns {Promise<Array>}
 */
export const fetchAllShopCategoryRows = async (params = {}) => {
    return fetchAllPaginatedList(
        ({ page, per_page }) =>
            getShopCategories({ ...params, page, per_page }),
        CATEGORY_PAGE_SIZE
    );
};

/**
 * 新增商品分類
 * @param {Object} data - 商品分類基本資料
 * @returns {Promise} API 響應
 */
export const createShopCategories = async (data) => {
    const url = '/api/admin/shop-categories';
    return apiService.POST(url, data);
};

/**
 * 更新商品分類
 * @param {Object} data - 商品分類基本資料
 * @returns {Promise} API 響應
 */
export const updateShopCategories = async (id, data) => {
    const url = `/api/admin/shop-categories/${id}`;
    return apiService.PUT(url, data);
};

/**
 * 刪除商品分類
 * @returns {Promise} API 響應
 */
export const deleteShopCategories = async (id) => {
    const url = `/api/admin/shop-categories/${id}`;
    return apiService.DELETE(url);
};

export const moveShopCategory = async (id, direction) => {
    return apiService.POST(`/api/admin/shop-categories/${id}/move`, { direction });
};

/**
 * 取得商品列表
 * @param {Object} params - 查詢參數
 * @param {number} params.page - 頁碼
 * @param {number} params.per_page - 每頁筆數
 * @returns {Promise} API 響應
 */
export const getShopProducts = async (params = {}) => {
    const url = '/api/admin/shop-products';
    return apiService.GET(url, params);
};

/**
 * 取得單個商品詳細資料
 * @param {number} id - 商品ID
 * @returns {Promise} API 響應
 */
export const getShopProduct = async (id) => {
    const url = `/api/admin/shop-products/${id}`;
    return apiService.GET(url);
};

/**
 * 新增商品
 * @param {Object} data - 商品基本資料
 * @returns {Promise} API 響應
 */
export const createShopProducts = async (data) => {
    const url = '/api/admin/shop-products';
    return apiService.POST(url, data);
};

/**
 * 更新商品
 * @param {number} id - 商品ID
 * @param {FormData} data - 商品基本資料（FormData，支援檔案上傳）
 * @returns {Promise} API 響應
 */
export const updateShopProducts = async (id, data) => {
    const url = `/api/admin/shop-products/${id}`;
    // 使用 POST 方法配合 _method=PUT（推薦，用於檔案上傳）
    // 確保 FormData 中包含 _method=PUT
    if (data instanceof FormData && !data.has('_method')) {
        data.append('_method', 'PUT');
    }
    return apiService.POST(url, data);
};

/**
 * 刪除商品
 * @returns {Promise} API 響應
 */
export const deleteShopProducts = async (id) => {
    const url = `/api/admin/shop-products/${id}`;
    return apiService.DELETE(url);
};

export const moveShopProduct = async (id, direction) => {
    return apiService.POST(`/api/admin/shop-products/${id}/move`, { direction });
};

/**
 * 取得商品選項（用於規則設定）
 * @returns {Promise} API 響應
 */
export const getShopProductOptions = async () => {
    const url = '/api/admin/shop-products/options';
    return apiService.GET(url);
};

export const listVendors = async () => {
    return apiService.GET('/api/admin/shop-vendors');
};

export const createVendor = async (data) => {
    return apiService.POST('/api/admin/shop-vendors', data);
};

export const updateVendor = async (id, data) => {
    return apiService.PUT(`/api/admin/shop-vendors/${id}`, data);
};
